import { useEffect, useState } from 'react';
import { useApi, formatPrice } from '../../lib/api';

type AdminListing = {
  listing_id: string;
  status: string;
  price_per_seat_cents: number;
  quantity_available: number;
  quantity_sold: number;
  listing_note: string | null;
  section: string;
  row: string;
  seats_json: string;
  section_type: string;
  opponent: string;
  game_date: string;
  seller_email: string;
};

const STATUSES = ['active', 'sold', 'cancelled', 'expired'] as const;

export default function AdminListings() {
  const api = useApi();
  const [status, setStatus] = useState<(typeof STATUSES)[number]>('active');
  const [listings, setListings] = useState<AdminListing[]>([]);
  const [busy, setBusy] = useState<string | null>(null);

  async function refresh() {
    const { listings } = await api<{ listings: AdminListing[] }>(`/admin/listings?status=${status}`);
    setListings(listings);
  }
  useEffect(() => {
    refresh().catch(console.error);
  }, [status]);

  async function cancel(id: string) {
    if (!window.confirm('Cancel this listing on behalf of the platform?')) return;
    setBusy(id);
    try {
      await api(`/admin/listings/${id}/cancel`, { method: 'POST' });
      await refresh();
    } finally {
      setBusy(null);
    }
  }

  return (
    <section>
      <h2>Listings</h2>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        {STATUSES.map((s) => (
          <button
            key={s}
            className={status === s ? 'btn' : 'btn-secondary'}
            onClick={() => setStatus(s)}
          >
            {s}
          </button>
        ))}
      </div>

      {listings.length === 0 && <p className="muted">No {status} listings.</p>}

      <div className="grid cols-3">
        {listings.map((l) => {
          const seats = JSON.parse(l.seats_json) as string[];
          return (
            <div className="card" key={l.listing_id}>
              <p>
                <strong>{l.opponent}</strong> — {l.game_date}
              </p>
              <p className="muted">
                Sec {l.section} Row {l.row} · Seats {seats.join(', ')} · {l.section_type}
              </p>
              <p className="muted">{l.seller_email}</p>
              <p className="price">{formatPrice(l.price_per_seat_cents)} / seat</p>
              <p className="muted">
                {l.quantity_sold}/{l.quantity_available} sold
              </p>
              {l.listing_note && <p className="muted">"{l.listing_note}"</p>}
              {(l.status === 'active' || l.status === 'sold') && (
                <button
                  className="btn-secondary"
                  disabled={busy === l.listing_id}
                  onClick={() => cancel(l.listing_id)}
                >
                  Cancel listing
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
